<template>
  <div class="form__container">
    <h3 data-test-id="building-construction-mode-heading" class="form__subtitle" v-html="$t('buildingConstructionMode')"></h3>
    <radio-group
      data-test-id="building-construction-mode"
      group="building-construction-mode"
      :options="constructionModeOptions"
      :label="$t('constructionMode')"
      v-model="building.constructionMode"
      :validation-feedback="constructionModeValidationFeedback"
      inline
    />
  </div>
</template>

<script>
import RadioGroup from '@/components/atoms/RadioGroup'
import Validators from '@/_helpers/validators'
import { synchronizeOwnership } from '@/_helpers/buildings'

export default {
  components: { RadioGroup },
  props: {
    building: Object
  },
  data() {
    return {
      constructionModeOptions: [
        { label: this.$t('constructionModeClassic'), value: 'CLASSIC', tooltip: this.$t('constructionModeClassicInfo') },
        { label: this.$t('constructionModeModular'), value: 'MODULAR', tooltip: this.$t('constructionModeModularInfo') }
      ]
    }
  },
  computed: {
    constructionModeValidationFeedback() {
      return Validators.required(this.building.constructionMode, this.$t('constructionModeRequired'))
    }
  },
  watch: {
    'building.constructionMode'() {
      if (this.building.constructionMode === `CLASSIC`) {
        this.building.plannedDates.productionStart = null
        this.building.plannedDates.productionEnd = null
      } else if (this.building.constructionMode === `MODULAR`) {
        this.building.plannedDates.insideWallCoverings = null
      }
      synchronizeOwnership(this.building)
    }
  }
}
</script>
